<template>
  <layout title="Courses">
    <div class="row">
      <div class="col-10">
        <h2 class="page-heading">
          <inertia-link
            class="previous-path-header"
            :href="route('notices.index')"
          >
            Notices
          </inertia-link>
          / Create
        </h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
          <div class="card-body col-md-8">
            <form @submit.prevent="create">
              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">Title</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="title"
                    placeholder=""
                    v-model="form.title"
                  />
                  <div v-if="errors && errors.title" class="d-block invalid-feedback">
                    {{ errors.title }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Notice
                </label>
                <div class="col-sm-10">
                  <textarea
                    class="form-control"
                    id="notice"
                    rows="5"
                    v-model="form.notice"
                  />
                   <div v-if="errors && errors.notice" class="d-block invalid-feedback">
                    {{ errors.notice }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Audience
                </label>
                <div class="col-sm-10">
                  <select class="form-control" v-model="form.target_role">
                    <option value="">All</option>
                    <option
                      v-for="role in noticeable_roles"
                      :key="role.id"
                      :value="role.id"
                    >
                      {{ role.name }}
                    </option>
                  </select>
                  <div
                    v-if="errors && errors.target_role"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.target_role }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <button type="submit" class="btn btn-primary float-right">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";

export default {
  layout: AppLayout,
  props: {
    errors: Object,
    noticeable_roles: Object
  },
  data() {
    return {
      form: {
        title: "",
        notice: "",
        target_role: ""
      },
    };
  },
  methods: {
    create() {
      this.$inertia.post(route("notices.store"), this.form);
    },
  },
};
</script>
